export type MenuItem = {
  label: string;
  to: string;
  description?: string;
};

export type MenuGroup = {
  title: string;
  items: MenuItem[];
};

export type MegaData = {
  heading: string;
  groups: MenuGroup[];
};

export const SOBRE_DATA: MegaData = {
  heading: "Sobre",
  groups: [
    {
      title: "Quem Somos",
      items: [
        {
          label: "Nossa História",
          to: "/sobre",
          description:
            "Transformamos o mercado de logística automotiva desde 201.",
        },
        {
          label: "Manifesto",
          to: "/sobre",
          description:
            "Acreditamos em novas rotas, novas formas e novos começos.",
        },
        {
          label: "Propósito e Valores",
          to: "/sobre",
          description:
            "Criar novos caminhos para a mobilidade, com segurança, agilidade e compromisso com o cliente.",
        },
      ],
    },
    {
      title: "Operação",
      items: [
        {
          label: "Unidades",
          to: "/sobre",
          description:
            "Temos unidades próprias em Salvador, Duque de Caxias, São Bernardo e São José, além de mais de 106.",
        },
        {
          label: "Números e Resultados",
          to: "/sobre",
          description:
            "Mais de 800 mil clientes atendidos e presença em mais de 3.000 cidades no último ano.",
        },
        {
          label: "Certificações",
          to: "/sobre",
          description:
            "Compromisso com excelência e segurança reconhecido por selos como o RA1000 e padrões.",
        },
      ],
    },
    {
      title: "Pessoas",
      items: [
        {
          label: "Conheça Nosso Time",
          to: "/equipe",
          description:
            "Profissionais que unem conhecimento, agilidade e empatia em cada atendimento.",
        },
        {
          label: "Cultura",
          to: "/sobre",
          description:
            "Valorizamos quem resolve, quem cuida e quem inova. Nossa cultura é orientada por entrega e evolução.",
        },
        {
          label: "Trabalhe Conosco",
          to: "/sobre",
          description:
            "Junte-se a um time apaixonado por mobilidade e pronto para transformar o setor automotivo.",
        },
        {
          label: "Seja um Parceiro",
          to: "/sobre",
          description:
            "Faça parte da nossa rede de mais de 10.000 transportadores credenciados e cresça com a gente.",
        },
      ],
    },
  ],
};

export const SOLUCOES_DATA: MegaData = {
  heading: "Soluções",
  groups: [
    {
      title: "Nossos Serviços:",
      items: [
        {
          label: "Transporte de Veículos Leves",
          to: "/tipo-de-veiculo",
          description: "Para carros novos, usados seminovos e inoperantes.",
        },
        {
          label: "Transporte de Motocicletas",
          to: "/tipo-de-veiculo",
          description: "Soluções porta a porta ou com guincho.",
        },
        {
          label: "Transporte de Embarcações",
          to: "/tipo-de-veiculo",
          description: "Soluções porta a porta em todo o Brasil.",
        },
        {
          label: "Serviço de Coleta Domiciliar",
          to: "/servicos",
          description: "Conforto e conveniência para você.",
        },
        {
          label: "Seguro com Cobertura Total",
          to: "/servicos",
          description: "Tranquilidade em toda a jornada.",
        },
        {
          label: "Inspeção Veicular Cautelar",
          to: "/servicos",
          description: "Verificamos seu veículo antes do transporte.",
        },
      ],
    },
    {
      title: "Para Você:",
      items: [
        {
          label: "Vai Mudar de Cidade?",
          to: "/pra-voce",
          description:
            "Transporte seguro e flexível para seu veículo na mudança.",
        },
        {
          label: "Comprou um Carro Online?",
          to: "/pra-voce",
          description: "Cuidamos da entrega até você, com inspeção e seguro.",
        },
        {
          label: "É Colecionador de Veículos?",
          to: "/pra-voce",
          description: "Especialistas em clássicos, antigos e premium.",
        },
        {
          label: "Vai Viajar de Carro?",
          to: "/pra-voce",
          description: "Enviamos seu carro para te encontrar no destino.",
        },
        {
          label: "É Militar ou Servidor Público?",
          to: "/pra-voce",
          description: "Atendemos remoções com prioridade e agilidade.",
        },
      ],
    },
    {
      title: "Para Empresas:",
      items: [
        {
          label: "Plataformas e E-commerces",
          to: "/para-sua-empresa",
          description:
            "Integração via API para entrega de veículos em domicílio.",
        },
        {
          label: "Frotistas e Locadoras",
          to: "/para-sua-empresa",
          description: "Mobilização, remanejamento e gestão de frota.",
        },
        {
          label: "Leiloeiros e Marketplaces",
          to: "/para-sua-empresa",
          description:
            "Infraestrutura completa para remoção, pátio, PDI e distribuição.",
        },
        {
          label: "Relocação Corporativa",
          to: "/para-sua-empresa",
          description: "Soluções para realocação de colaboradores e veículos.",
        },
      ],
    },
  ],
};
